import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TenantToggle, UserRule } from '@verify/shared-components/models';
import { AuthService } from '@verify/shared-components/services';
import { combineLatest, filter, map, take } from 'rxjs';

export const projectsGuard: CanActivateFn = () => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);

  return combineLatest([authService.tenant$, authService.currentUser$]).pipe(
    filter(([tenant, user]) => !!tenant && !!user),
    take(1),
    map(([tenant, user]) =>
      user?.rules?.every(
        (rule) =>
          ![
            UserRule.projectAdmin,
            UserRule.projectEditing,
            UserRule.projectManagement,
            UserRule.projectDownloading,
            UserRule.projectUploading,
          ].includes(rule),
      )
        ? router.parseUrl('error?code=403')
        : (tenant?.toggles || []).includes(TenantToggle.monitoringProjectsOnly)
          ? router.parseUrl('/collections')
          : true,
    ),
  );
};
